export namespace MCU {
	export enum Type {
		// https://en.wikipedia.org/wiki/List_of_Marvel_Cinematic_Universe_films
		Movie = "Movie",
		// https://en.wikipedia.org/wiki/List_of_Marvel_Cinematic_Universe_television_series
		Show = "Show",
		ShowABC = "Show (ABC)",
		ShowNetflix = "Show (Netflix)",
	}
	export enum Phase {
		One = "Phase 1",
		Two = "Phase 2",
		Three = "Phase 3",
		Four = "Phase 4",
		Five = "Phase 5",
		Six = "Phase 6",
	}

	export enum Saga {
		Infinity = "Infinity Saga",
		Multiverse = "Multiverse Saga",
	}

	export type Entry = {
		Title: string
		Released: Date | null
		Type: Type
		Saga: Saga
		Phase: Phase
		DisneyPlus?: string
	}

	export const Entries: Entry[] = [
		{
			Phase: Phase.One,
			Released: new Date("2008-05-02 10:00:00Z"),
			Saga: Saga.Infinity,
			Title: "Iron Man",
			Type: Type.Movie,
		},
		{
			Phase: Phase.One,
			Released: new Date("2008-06-13 10:00:00Z"),
			Saga: Saga.Infinity,
			Title: "The Incredible Hulk",
			Type: Type.Movie,
		},
		{
			Phase: Phase.One,
			Released: new Date("2010-05-07 10:00:00Z"),
			Saga: Saga.Infinity,
			Title: "Iron Man 2",
			Type: Type.Movie,
		},
		{
			Phase: Phase.One,
			Released: new Date("2011-05-06 10:00:00Z"),
			Saga: Saga.Infinity,
			Title: "Thor",
			Type: Type.Movie,
		},
		{
			Phase: Phase.One,
			Released: new Date("2011-07-22 10:00:00Z"),
			Saga: Saga.Infinity,
			Title: "Captain America: The First Avenger",
			Type: Type.Movie,
		},
		{
			Phase: Phase.One,
			Released: new Date("2012-05-04 10:00:00Z"),
			Saga: Saga.Infinity,
			Title: "The Avengers",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2013-05-03"),
			Saga: Saga.Infinity,
			Title: "Iron Man 3",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2013-09-24"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 1",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2013-11-08"),
			Saga: Saga.Infinity,
			Title: "Thor: The Dark World",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2014-04-04"),
			Saga: Saga.Infinity,
			Title: "Captain America: The Winter Soldier",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2014-08-01"),
			Saga: Saga.Infinity,
			Title: "Guardians of the Galaxy",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2014-09-23"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 2",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2015-01-06"),
			Saga: Saga.Infinity,
			Title: "Agent Carter Season 1",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2015-04-10"),
			Saga: Saga.Infinity,
			Title: "Daredevil Season 1",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2015-05-01"),
			Saga: Saga.Infinity,
			Title: "Avengers: Age of Ultron",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2015-07-17"),
			Saga: Saga.Infinity,
			Title: "Ant-Man",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2015-09-29"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 3",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2015-11-20"),
			Saga: Saga.Infinity,
			Title: "Jessica Jones Season 1",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2016-01-19"),
			Saga: Saga.Infinity,
			Title: "Agent Carter Season 2",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Two,
			Released: new Date("2016-03-18"),
			Saga: Saga.Infinity,
			Title: "Daredevil Season 2",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2016-05-06"),
			Saga: Saga.Infinity,
			Title: "Captain America: Civil War",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2016-09-30"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 4",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2016-09-30"),
			Saga: Saga.Infinity,
			Title: "Luke Cage Season 1",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2016-11-04"),
			Saga: Saga.Infinity,
			Title: "Doctor Strange",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-03-17"),
			Saga: Saga.Infinity,
			Title: "Iron Fist Season 1",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-05-05"),
			Saga: Saga.Infinity,
			Title: "Guardians of the Galaxy Vol. 2",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-07-07"),
			Saga: Saga.Infinity,
			Title: "Spider-Man: Homecoming",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-08-18"),
			Saga: Saga.Infinity,
			Title: "The Defenders",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-09-29"),
			Saga: Saga.Infinity,
			Title: "Inhumans",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-11-03"),
			Saga: Saga.Infinity,
			Title: "Thor: Ragnarok",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2017-11-17"),
			Saga: Saga.Infinity,
			Title: "The Punisher Season 1",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2016-12-01"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 5",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-02-16"),
			Saga: Saga.Infinity,
			Title: "Black Panther",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-03-08"),
			Saga: Saga.Infinity,
			Title: "Jessica Jones Season 2",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-04-27"),
			Saga: Saga.Infinity,
			Title: "Avengers: Infinity War",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-06-22"),
			Saga: Saga.Infinity,
			Title: "Luke Cage Season 2",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-07-06"),
			Saga: Saga.Infinity,
			Title: "Ant-Man and the Wasp",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-09-07"),
			Saga: Saga.Infinity,
			Title: "Iron Fist Season 2",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2018-10-19"),
			Saga: Saga.Infinity,
			Title: "Daredevil Season 3",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2019-01-18"),
			Saga: Saga.Infinity,
			Title: "The Punisher Season 2",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2019-03-08"),
			Saga: Saga.Infinity,
			Title: "Captain Marvel",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2019-04-26"),
			Saga: Saga.Infinity,
			Title: "Avengers: Endgame",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2019-05-10"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 6",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2019-06-14"),
			Saga: Saga.Infinity,
			Title: "Jessica Jones Season 3",
			Type: Type.ShowNetflix,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2019-07-02"),
			Saga: Saga.Infinity,
			Title: "Spider-Man: Far From Home",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Three,
			Released: new Date("2020-05-27"),
			Saga: Saga.Infinity,
			Title: "Agents of S.H.I.E.L.D. Season 7",
			Type: Type.ShowABC,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-07-09"),
			Saga: Saga.Multiverse,
			Title: "Black Widow",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-09-03"),
			Saga: Saga.Multiverse,
			Title: "Shang-Chi and the Legend of the Ten Rings",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-11-05"),
			Saga: Saga.Multiverse,
			Title: "Eternals",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-12-17"),
			Saga: Saga.Multiverse,
			Title: "Spider-Man: No Way Home",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2022-05-06"),
			Saga: Saga.Multiverse,
			Title: "Doctor Strange in the Multiverse of Madness",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2022-07-08"),
			Saga: Saga.Multiverse,
			Title: "Thor: Love and Thunder",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2022-11-11"),
			Saga: Saga.Multiverse,
			Title: "Black Panther: Wakanda Forever",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2023-02-17"),
			Saga: Saga.Multiverse,
			Title: "Ant-Man and the Wasp: Quantumania",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2023-05-05"),
			Saga: Saga.Multiverse,
			Title: "Guardians of the Galaxy Vol. 3",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2023-11-10"),
			Saga: Saga.Multiverse,
			Title: "The Marvels",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2024-07-26"),
			Saga: Saga.Multiverse,
			Title: "Deadpool & Wolverine",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2025-02-14"),
			Saga: Saga.Multiverse,
			Title: "Captain America: Brave New World",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2025-05-02"),
			Saga: Saga.Multiverse,
			Title: "Thunderbolts*",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Six,
			Released: new Date("2025-07-25"),
			Saga: Saga.Multiverse,
			Title: "The Fantastic Four: First Steps",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Six,
			Released: new Date("2026-12-18"),
			Saga: Saga.Multiverse,
			Title: "Avengers: Doomsday",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Six,
			Released: new Date("2026-07-31"),
			Saga: Saga.Multiverse,
			Title: "Spider-Man: Brand New Day",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Six,
			Released: new Date("2027-12-17"),
			Saga: Saga.Multiverse,
			Title: "Avengers: Secret Wars",
			Type: Type.Movie,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-01-15"),
			Saga: Saga.Multiverse,
			Title: "WandaVision",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-03-19"),
			Saga: Saga.Multiverse,
			Title: "The Falcon and the Winter Soldier",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-06-09"),
			Saga: Saga.Multiverse,
			Title: "Loki Season 1",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-08-11"),
			Saga: Saga.Multiverse,
			Title: "What If...? Season 1",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2021-11-24"),
			Saga: Saga.Multiverse,
			Title: "Hawkeye",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2022-03-30"),
			Saga: Saga.Multiverse,
			Title: "Moon Knight",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2022-06-08"),
			Saga: Saga.Multiverse,
			Title: "Ms. Marvel",
			Type: Type.Show,
		},
		{
			Phase: Phase.Four,
			Released: new Date("2022-08-18"),
			Saga: Saga.Multiverse,
			Title: "She-Hulk: Attorney at Law",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2023-06-21"),
			Saga: Saga.Multiverse,
			Title: "Secret Invasion",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2023-10-05"),
			Saga: Saga.Multiverse,
			Title: "Loki Season 2",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2023-12-22"),
			Saga: Saga.Multiverse,
			Title: "What If...? Season 2",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2024-12-22"),
			Saga: Saga.Multiverse,
			Title: "What If...? Season 3",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2024-01-09"),
			Saga: Saga.Multiverse,
			Title: "Echo",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2024-09-18"),
			Saga: Saga.Multiverse,
			Title: "Agatha All Along",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2025-01-29"),
			Saga: Saga.Multiverse,
			Title: "Your Friendly Neighborhood Spider-Man Season 1",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2025-03-04"),
			Saga: Saga.Multiverse,
			Title: "Daredevil: Born Again Season 1",
			Type: Type.Show,
		},
		{
			Phase: Phase.Five,
			Released: new Date("2025-06-24"),
			Saga: Saga.Multiverse,
			Title: "Ironheart",
			Type: Type.Show,
		},
		{
			Phase: Phase.Six,
			Released: new Date("2025-08-06"),
			Saga: Saga.Multiverse,
			Title: "Eyes of Wakanda",
			Type: Type.Show,
		},
		{
			Phase: Phase.Six,
			Released: new Date("2025-10-03"),
			Saga: Saga.Multiverse,
			Title: "Marvel Zombies",
			Type: Type.Show,
		},
		{
			Phase: Phase.Six,
			Released: null,
			Saga: Saga.Multiverse,
			Title: "Wonder Man",
			Type: Type.Show,
		},
		{
			Phase: Phase.Six,
			Released: null,
			Saga: Saga.Multiverse,
			Title: "Daredevil: Born Again Season 2",
			Type: Type.Show,
		},
		{
			Phase: Phase.Six,
			Released: null,
			Saga: Saga.Multiverse,
			Title: "Vision Quest",
			Type: Type.Show,
		},
		{
			Phase: Phase.Six,
			Released: null,
			Saga: Saga.Multiverse,
			Title: "Your Friendly Neighborhood Spider-Man Season 2",
			Type: Type.Show,
		},
	]
}
